<template>
    <v-dialog v-model="dialog" max-width="800px" max-height="500px" persistent overlay-opacity="0.75">
      	<v-card class="elevation-0 grey darken-3">
			<v-toolbar color="blue-grey darken-3" dark dense elevation="0">
				<v-toolbar-title>{{ cfgTable.model_title }}:</v-toolbar-title>
				<v-text-field flat solo dense hide-details background-color="blue-grey darken-4" readonly :value="item.name" class="mx-3"
				></v-text-field>  
				<v-spacer></v-spacer>
				<v-btn disabled plain small>ID: {{ item.id }}</v-btn>
				<v-btn ripple icon><v-icon color="yellow darken-3">mdi-star</v-icon></v-btn>
			</v-toolbar>
			<v-card-title>Aktionen:</v-card-title>
        	<v-card-text>
				<v-row><v-col v-for="(action, index) in cfgActions" :key="index">
				<v-btn
					class="mx-5" :color="action.color"
					@click="onAction(action)"><v-icon left>{{ action.icon }}</v-icon>{{ action.title }}
				</v-btn>
				</v-col></v-row>
			</v-card-text>
        	<v-card-actions>
				<v-spacer />
        		<v-btn text class="warning mx-0 mb-2" @click="onCancel()">Beenden</v-btn>
        	</v-card-actions>
      	</v-card>
    </v-dialog>          
</template>
<script>

export default {
	name: "GenericAction",
	components: {},
	props: {
		modulData: {
			type: Object,
			required: true,
			default: null,
		},
	},
	data: () => ({
		dialog: false,
		loading: false,
		cfgTable: {},
		cfgActions: [],
		item: {},
	}),
	computed: {
	},
	methods: {
		closeDialog(event) {
			this.loading = false
			this.dialog = false
			this.$emit(event)
		},
		onCancel() {
			this.closeDialog('cancelled')
		},
		onAction(action) {
			if(action.newtab) {
				const url = new URL(window.location.origin)
				const baseURL = url.protocol + '//' + url.hostname
				const path = baseURL + '/' + this.modulData.meta.tablename + '/' + this.modulData.meta.item.id + '/action?type=' + action.action
				//console.log('onAction path:', path)
				window.open(path, "_blank")
			}
		},
		getCfgs() {
			//console.log('modulData:', this.modulData)
			const param = {
				table_name: this.modulData.meta.subtable,
				reftable: this.modulData.meta.tablename,
                context: this.modulData.meta.modelname,
			}
			//console.log('param:', param)
			this.cfgTable = this.$store.getters['core/getCfgTable'](param)
			this.cfgActions = this.$store.getters['core/getCfgActions'](param)
			//console.log('actions:', this.cfgActions)
		},
	},
	beforeMount() {
		this.getCfgs()
		this.dialog = true
	},
	mounted() {
		this.item = Object.assign({}, this.modulData.meta.model)
		//console.log('Actions:', this.cfgActions)
		//this.$emit('ready')
	},
	watch: {
	},
}  
</script>

<style>
.theme--dark.v-label {
    color: rgba(255, 255, 255, 0.3);
}
</style>
